export const blockIconsAudioandvideoPlayCircleOutline = (
	<span className='material-symbols-outlined'>play_circle_outline</span>
);
